// // index.js

// // This file is automatically generated by a script.
// // Do not manually edit this file.

// import { ReactComponent as Activityicon } from "./Icon/ActivityIcon.svg";
// import { ReactComponent as Addcircleicon } from "./Icon/AddCircleIcon.svg";
// import { ReactComponent as Addicon } from "./Icon/AddIcon.svg";
// import { ReactComponent as Additemicon } from "./Icon/AddItemIcon.svg";
// import { ReactComponent as Addonicon } from "./Icon/AddonIcon.svg";
// import { ReactComponent as Appaccessicon } from "./Icon/AppAccessIcon.svg";
// import { ReactComponent as Appswitchericon } from "./Icon/AppSwitcherIcon.svg";
// import { ReactComponent as Archiveicon } from "./Icon/ArchiveIcon.svg";
// import { ReactComponent as Arrowdowncircleicon } from "./Icon/ArrowDownCircleIcon.svg";
// import { ReactComponent as Arrowdownicon } from "./Icon/ArrowDownIcon.svg";
// import { ReactComponent as Arrowleftcircleicon } from "./Icon/ArrowLeftCircleIcon.svg";
// import { ReactComponent as Arrowlefticon } from "./Icon/ArrowLeftIcon.svg";
// import { ReactComponent as Arrowrightcircleicon } from "./Icon/ArrowRightCircleIcon.svg";
// import { ReactComponent as Arrowrighticon } from "./Icon/ArrowRightIcon.svg";
// import { ReactComponent as Arrowupcircleicon } from "./Icon/ArrowUpCircleIcon.svg";
// import { ReactComponent as Arrowupicon } from "./Icon/ArrowUpIcon.svg";
// import { ReactComponent as Attachmenticon } from "./Icon/AttachmentIcon.svg";
// import { ReactComponent as Audiocircleicon } from "./Icon/AudioCircleIcon.svg";
// import { ReactComponent as Audioicon } from "./Icon/AudioIcon.svg";
// import { ReactComponent as Audioonlyicon } from "./Icon/AudioOnlyIcon.svg";
import { ReactComponent as Backlogicon } from "./Icon/BacklogIcon.svg";
// import { ReactComponent as Billingfilledicon } from "./Icon/BillingFilledIcon.svg";
// import { ReactComponent as Billingicon } from "./Icon/BillingIcon.svg";
// import { ReactComponent as Blogicon } from "./Icon/BlogIcon.svg";
// import { ReactComponent as Boardicon } from "./Icon/BoardIcon.svg";
import { ReactComponent as Bookicon } from "./Icon/BookIcon.svg";
// import { ReactComponent as Bulletlisticon } from "./Icon/BulletListIcon.svg";
// import { ReactComponent as Calendarfilledicon } from "./Icon/CalendarFilledIcon.svg";
// import { ReactComponent as Calendaricon } from "./Icon/CalendarIcon.svg";
// import { ReactComponent as Camerafilledicon } from "./Icon/CameraFilledIcon.svg";
// import { ReactComponent as Cameraicon } from "./Icon/CameraIcon.svg";
import { ReactComponent as Cash } from "./Icon/Cash.svg";
import { ReactComponent as Pi } from "../icons/pi.svg";
// import { ReactComponent as Bitbuckerbranchesicon } from "./Icon/_BitbuckerBranchesIcon_.svg";
// import { ReactComponent as Bitbuckerbuildsicon } from "./Icon/_BitbuckerBuildsIcon_.svg";
// import { ReactComponent as Bitbuckercloneicon } from "./Icon/_BitbuckerCloneIcon_.svg";
// import { ReactComponent as Bitbuckercommitsicon } from "./Icon/_BitbuckerCommitsIcon_.svg";
// import { ReactComponent as Bitbuckercompareicon } from "./Icon/_BitbuckerCompareIcon_.svg";
// import { ReactComponent as Bitbuckerdeploymentsicon } from "./Icon/_BitbuckerDeploymentsIcon_.svg";
// import { ReactComponent as Bitbuckerforksicon } from "./Icon/_BitbuckerForksIcon_.svg";
// import { ReactComponent as Bitbuckeroutputicon } from "./Icon/_BitbuckerOutputIcon_.svg";
// import { ReactComponent as Bitbuckerpipelinesicon } from "./Icon/_BitbuckerPipelinesIcon_.svg";
// import { ReactComponent as Bitbuckerpullrequestsicon } from "./Icon/_BitbuckerPullrequestsIcon_.svg";
// import { ReactComponent as Bitbuckerreposicon } from "./Icon/_BitbuckerReposIcon_.svg";
// import { ReactComponent as Bitbuckersnippetsicon } from "./Icon/_BitbuckerSnippetsIcon_.svg";
// import { ReactComponent as Bitbuckersourceicon } from "./Icon/_BitbuckerSourceIcon_.svg";
// import { ReactComponent as Camerarotateicon } from "./Icon/_CameraRotateIcon_.svg";
// import { ReactComponent as Cameratakepictureicon } from "./Icon/_CameraTakePictureIcon_.svg";
// import { ReactComponent as Canvasicon } from "./Icon/_CanvasIcon_.svg";
// import { ReactComponent as Checkboxicon } from "./Icon/_CheckboxIcon_.svg";
// import { ReactComponent as Checkboxindeterminateicon } from "./Icon/_CheckboxIndeterminateIcon_.svg";
// import { ReactComponent as Checkcircleicon } from "./Icon/_CheckCircleIcon_.svg";
// import { ReactComponent as Checkcircleoutlineicon } from "./Icon/_CheckCircleOutlineIcon_.svg";
// import { ReactComponent as Checkicon } from "./Icon/_CheckIcon_.svg";
// import { ReactComponent as Chevrondoubledownicon } from "./Icon/_ChevronDoubleDownIcon_.svg";
// import { ReactComponent as Chevrondoubleupicon } from "./Icon/_ChevronDoubleUpIcon_.svg";
// import { ReactComponent as Chevrondowncircleicon } from "./Icon/_ChevronDownCircleIcon_.svg";
// import { ReactComponent as Chevrondownicon1 } from "./Icon/_ChevronDownIcon_-1.svg";
// import { ReactComponent as Chevrondownicon } from "./Icon/_ChevronDownIcon_.svg";
// import { ReactComponent as Chevronleftcircleicon } from "./Icon/_ChevronLeftCircleIcon_.svg";
// import { ReactComponent as Chevronlefticon } from "./Icon/_ChevronLeftIcon_.svg";
// import { ReactComponent as Chevronleftlargeicon } from "./Icon/_ChevronLeftLargeIcon_.svg";
import { ReactComponent as Chevronrightcircleicon } from "./Icon/_ChevronRightCircleIcon_.svg";
// import { ReactComponent as Chevronrighticon } from "./Icon/_ChevronRightIcon_.svg";
// import { ReactComponent as Chevronrightlargeicon } from "./Icon/_ChevronRightLargeIcon_.svg";
// import { ReactComponent as Chevronupcircleicon } from "./Icon/_ChevronUpCircleIcon_.svg";
// import { ReactComponent as Chevronupicon1 } from "./Icon/_ChevronUpIcon_-1.svg";
// import { ReactComponent as Chevronupicon } from "./Icon/_ChevronUpIcon_.svg";
// import { ReactComponent as Childissuesicon } from "./Icon/_ChildIssuesIcon_.svg";
// import { ReactComponent as Codeicon } from "./Icon/_CodeIcon_.svg";
// import { ReactComponent as Commenticon } from "./Icon/_CommentIcon_.svg";
// import { ReactComponent as Componenticon } from "./Icon/_ComponentIcon_.svg";
// import { ReactComponent as Copyicon } from "./Icon/_CopyIcon_.svg";
// import { ReactComponent as Creditcardfilledicon } from "./Icon/_CreditcardFilledIcon_.svg";
// import { ReactComponent as Creditcardicon } from "./Icon/_CreditcardIcon_.svg";
// import { ReactComponent as Crosscircleicon } from "./Icon/_CrossCircleIcon_.svg";
// import { ReactComponent as Crossicon } from "./Icon/_CrossIcon_.svg";
// import { ReactComponent as Dashboardicon } from "./Icon/_DashboardIcon_.svg";
// import { ReactComponent as Decisionicon } from "./Icon/_DecisionIcon_.svg";
// import { ReactComponent as Departmenticon } from "./Icon/_DepartmentIcon_.svg";
// import { ReactComponent as Detailviewicon } from "./Icon/_DetailViewIcon_.svg";
import { ReactComponent as Dialouticon } from "./Icon/_DialOutIcon_.svg";
// import { ReactComponent as Discoverfilledicon } from "./Icon/_DiscoverFilledIcon_.svg";
// import { ReactComponent as Discovericon } from "./Icon/_DiscoverIcon_.svg";
// import { ReactComponent as Documentfilledicon } from "./Icon/_DocumentFilledIcon_.svg";
// import { ReactComponent as Documenticon } from "./Icon/_DocumentIcon_.svg";
// import { ReactComponent as Documentsicon } from "./Icon/_DocumentsIcon_.svg";
// import { ReactComponent as Downloadicon } from "./Icon/_DownloadIcon_.svg";
// import { ReactComponent as Draghandlericon } from "./Icon/_DragHandlerIcon_.svg";
// import { ReactComponent as Dropboxicon } from "./Icon/_DropboxIcon_.svg";
// import { ReactComponent as Editfilledicon } from "./Icon/_EditFilledIcon_.svg";
// import { ReactComponent as Editicon } from "./Icon/_EditIcon_.svg";
// import { ReactComponent as Editoraddicon } from "./Icon/_EditorAddIcon_.svg";
// import { ReactComponent as Editoraddonicon } from "./Icon/_EditorAddonIcon_.svg";
// import { ReactComponent as Editoradvancedicon } from "./Icon/_EditorAdvancedIcon_.svg";
// import { ReactComponent as Editoraligncentericon } from "./Icon/_EditorAlignCenterIcon_.svg";
// import { ReactComponent as Editoralignimagecentericon } from "./Icon/_EditorAlignImageCenterIcon_.svg";
// import { ReactComponent as Editoralignimagelefticon } from "./Icon/_EditorAlignImageLeftIcon_.svg";
// import { ReactComponent as Editoralignimagerighticon } from "./Icon/_EditorAlignImageRightIcon_.svg";
// import { ReactComponent as Editoralignlefticon } from "./Icon/_EditorAlignLeftIcon_.svg";
// import { ReactComponent as Editoralignrighticon } from "./Icon/_EditorAlignRightIcon_.svg";
// import { ReactComponent as Editorattachmenticon } from "./Icon/_EditorAttachmentIcon_.svg";
// import { ReactComponent as Editorbackgroundcoloricon } from "./Icon/_EditorBackgroundColorIcon_.svg";
// import { ReactComponent as Editorboldicon } from "./Icon/_EditorBoldIcon_.svg";
// import { ReactComponent as Editorbulletlisticon } from "./Icon/_EditorBulletListIcon_.svg";
// import { ReactComponent as Editorcloseicon } from "./Icon/_EditorCloseIcon_.svg";
// import { ReactComponent as Editorcodeicon } from "./Icon/_EditorCodeIcon_.svg";
// import { ReactComponent as Editorcollapseicon } from "./Icon/_EditorCollapseIcon_.svg";
// import { ReactComponent as Editordateicon } from "./Icon/_EditorDateIcon_.svg";
// import { ReactComponent as Editordecisionicon } from "./Icon/_EditorDecisionIcon_.svg";
// import { ReactComponent as Editordividericon } from "./Icon/_EditorDividerIcon_.svg";
// import { ReactComponent as Editordoneicon } from "./Icon/_EditorDoneIcon_.svg";
// import { ReactComponent as Editorediticon } from "./Icon/_EditorEditIcon_.svg";
// import { ReactComponent as Editoremojiicon } from "./Icon/_EditorEmojiIcon_.svg";
// import { ReactComponent as Editorerroricon } from "./Icon/_EditorErrorIcon_.svg";
// import { ReactComponent as Editorexpandicon } from "./Icon/_EditorExpandIcon_.svg";
// import { ReactComponent as Editorfeedbackicon } from "./Icon/_EditorFeedbackIcon_.svg";
// import { ReactComponent as Editorfileicon } from "./Icon/_EditorFileIcon_.svg";
// import { ReactComponent as Editorfilepreviewicon } from "./Icon/_EditorFilePreviewIcon_.svg";
// import { ReactComponent as Editorhelpicon } from "./Icon/_EditorHelpIcon_.svg";
// import { ReactComponent as Editorhinticon } from "./Icon/_EditorHintIcon_.svg";
// import { ReactComponent as Editorhorizontalruleicon } from "./Icon/_EditorHorizontalRuleIcon_.svg";
// import { ReactComponent as Editorimagebordericon } from "./Icon/_EditorImageBorderIcon_.svg";
// import { ReactComponent as Editorimageicon } from "./Icon/_EditorImageIcon_.svg";
// import { ReactComponent as Editorimageresizeicon } from "./Icon/_EditorImageResizeIcon_.svg";
// import { ReactComponent as Editorindenticon } from "./Icon/_EditorIndentIcon_.svg";
// import { ReactComponent as Editorinfoicon } from "./Icon/_EditorInfoIcon_.svg";
// import { ReactComponent as Editoritalicicon } from "./Icon/_EditorItalicIcon_.svg";
// import { ReactComponent as Editorlayoutsingleicon } from "./Icon/_EditorLayoutSingleIcon_.svg";
// import { ReactComponent as Editorlayoutthreeequalicon } from "./Icon/_EditorLayoutThreeEqualIcon_.svg";
// import { ReactComponent as Editorlayoutthreewithsidebarsicon } from "./Icon/_EditorLayoutThreeWithSidebarsIcon_.svg";
// import { ReactComponent as Editorlayouttwoequalicon } from "./Icon/_EditorLayoutTwoEqualIcon_.svg";
// import { ReactComponent as Editorlayouttwoleftsidebaricon } from "./Icon/_EditorLayoutTwoLeftSidebarIcon_.svg";
// import { ReactComponent as Editorlayouttworightsidebaricon } from "./Icon/_EditorLayoutTwoRightSidebarIcon_.svg";
// import { ReactComponent as Editorlinkicon } from "./Icon/_EditorLinkIcon_.svg";
// import { ReactComponent as Editormediacentericon } from "./Icon/_EditorMediaCenterIcon_.svg";
// import { ReactComponent as Editormediafullwidthicon } from "./Icon/_EditorMediaFullWidthIcon_.svg";
// import { ReactComponent as Editormediawideicon } from "./Icon/_EditorMediaWideIcon_.svg";
// import { ReactComponent as Editormediawraplefticon } from "./Icon/_EditorMediaWrapLeftIcon_.svg";
// import { ReactComponent as Editormediawraprighticon } from "./Icon/_EditorMediaWrapRightIcon_.svg";
// import { ReactComponent as Editormentionicon } from "./Icon/_EditorMentionIcon_.svg";
// import { ReactComponent as Editormoreicon } from "./Icon/_EditorMoreIcon_.svg";
// import { ReactComponent as Editornoteicon } from "./Icon/_EditorNoteIcon_.svg";
// import { ReactComponent as Editornumberlisticon } from "./Icon/_EditorNumberListIcon_.svg";
// import { ReactComponent as Editoropenicon } from "./Icon/_EditorOpenIcon_.svg";
// import { ReactComponent as Editoroutdenticon } from "./Icon/_EditorOutdentIcon_.svg";
// import { ReactComponent as Editorpanelicon } from "./Icon/_EditorPanelIcon_.svg";
// import { ReactComponent as Editorphotoicon } from "./Icon/_EditorPhotoIcon_.svg";
// import { ReactComponent as Editorquoteicon } from "./Icon/_EditorQuoteIcon_.svg";
// import { ReactComponent as Editorrecenticon } from "./Icon/_EditorRecentIcon_.svg";
// import { ReactComponent as Editorredoicon } from "./Icon/_EditorRedoIcon_.svg";
// import { ReactComponent as Editorremoveemojiicon } from "./Icon/_EditorRemoveEmojiIcon_.svg";
// import { ReactComponent as Editorremoveicon } from "./Icon/_EditorRemoveIcon_.svg";
// import { ReactComponent as Editorsearchicon } from "./Icon/_EditorSearchIcon_.svg";
// import { ReactComponent as Editorsettingsicon } from "./Icon/_EditorSettingsIcon_.svg";
// import { ReactComponent as Editorstrikethroughicon } from "./Icon/_EditorStrikethroughIcon_.svg";
// import { ReactComponent as Editorsuccessicon } from "./Icon/_EditorSuccessIcon_.svg";
// import { ReactComponent as Editortabledisplayoptionsicon1 } from "./Icon/_EditorTableDisplayOptionsIcon_-1.svg";
// import { ReactComponent as Editortabledisplayoptionsicon } from "./Icon/_EditorTableDisplayOptionsIcon_.svg";
// import { ReactComponent as Editortableicon } from "./Icon/_EditorTableIcon_.svg";
// import { ReactComponent as Editortaskicon } from "./Icon/_EditorTaskIcon_.svg";
// import { ReactComponent as Editortextcoloricon } from "./Icon/_EditorTextColorIcon_.svg";
// import { ReactComponent as Editortextstyleicon } from "./Icon/_EditorTextStyleIcon_.svg";
// import { ReactComponent as Editorunderlineicon } from "./Icon/_EditorUnderlineIcon_.svg";
// import { ReactComponent as Editorundoicon } from "./Icon/_EditorUndoIcon_.svg";
// import { ReactComponent as Editorunlinkicon } from "./Icon/_EditorUnlinkIcon_.svg";
// import { ReactComponent as Editorwarningicon } from "./Icon/_EditorWarningIcon_.svg";
// import { ReactComponent as Emailicon } from "./Icon/_EmailIcon_.svg";
// import { ReactComponent as Emojiactivity } from "./Icon/_EmojiActivity_.svg";
// import { ReactComponent as Emojiaddicon } from "./Icon/_EmojiAddIcon_.svg";
// import { ReactComponent as Emojiatlassian } from "./Icon/_EmojiAtlassian_.svg";
// import { ReactComponent as Emojicustom } from "./Icon/_EmojiCustom_.svg";
// import { ReactComponent as Emojiemoji } from "./Icon/_EmojiEmoji_.svg";
// import { ReactComponent as Emojiflags } from "./Icon/_EmojiFlags_.svg";
// import { ReactComponent as Emojifood } from "./Icon/_EmojiFood_.svg";
// import { ReactComponent as Emojifrequent } from "./Icon/_EmojiFrequent_.svg";
// import { ReactComponent as Emojiicon } from "./Icon/_EmojiIcon_.svg";
// import { ReactComponent as Emojikeyboard } from "./Icon/_EmojiKeyboard_.svg";
// import { ReactComponent as Emojinature } from "./Icon/_EmojiNature_.svg";
// import { ReactComponent as Emojiobjects } from "./Icon/_EmojiObjects_.svg";
// import { ReactComponent as Emojipeople } from "./Icon/_EmojiPeople_.svg";
// import { ReactComponent as Emojiproductivity } from "./Icon/_EmojiProductivity_.svg";
// import { ReactComponent as Emojisymbols } from "./Icon/_EmojiSymbols_.svg";
// import { ReactComponent as Emojitravel } from "./Icon/_EmojiTravel_.svg";
// import { ReactComponent as Erroricon } from "./Icon/_ErrorIcon_.svg";
// import { ReactComponent as Exporticon } from "./Icon/_ExportIcon_.svg";
// import { ReactComponent as Feedbackicon } from "./Icon/_FeedbackIcon_.svg";
// import { ReactComponent as Fileicon } from "./Icon/_FileIcon_.svg";
// import { ReactComponent as Filtericon } from "./Icon/_FilterIcon_.svg";
// import { ReactComponent as Flagfilledicon } from "./Icon/_FlagFilledIcon_.svg";
// import { ReactComponent as Folderfilledicon } from "./Icon/_FolderFilledIcon_.svg";
// import { ReactComponent as Foldericon } from "./Icon/_FolderIcon_.svg";
// import { ReactComponent as Followersicon } from "./Icon/_FollowersIcon_.svg";
// import { ReactComponent as Followingicon } from "./Icon/_FollowingIcon_.svg";
// import { ReactComponent as Googledriveicon } from "./Icon/_GoogledriveIcon_.svg";
// import { ReactComponent as Graphbaricon } from "./Icon/_GraphBarIcon_.svg";
// import { ReactComponent as Graphlineicon } from "./Icon/_GraphLineIcon_.svg";
// import { ReactComponent as Gsuiteicon } from "./Icon/_GsuiteIcon_.svg";
import { ReactComponent as Highlightsicon } from "./Icon/_HighlightsIcon_.svg";
// import { ReactComponent as Homecircleicon } from "./Icon/_HomeCircleIcon_.svg";
import { ReactComponent as Homeicon } from "./Icon/_HomeIcon_.svg";
// import { ReactComponent as Imagebordericon } from "./Icon/_ImageBorderIcon_.svg";
// import { ReactComponent as Imageicon } from "./Icon/_ImageIcon_.svg";
// import { ReactComponent as Imageresizeicon } from "./Icon/_ImageResizeIcon_.svg";
// import { ReactComponent as Infoicon } from "./Icon/_InfoIcon_.svg";
// import { ReactComponent as Inviteteamicon } from "./Icon/_InviteTeamIcon_.svg";
// import { ReactComponent as Issueicon } from "./Icon/_IssueIcon_.svg";
// import { ReactComponent as Issueraiseicon } from "./Icon/_IssueRaiseIcon_.svg";
// import { ReactComponent as Issuesicon } from "./Icon/_IssuesIcon_.svg";
// import { ReactComponent as Jiracaptureicon } from "./Icon/_JiraCaptureIcon_.svg";
// import { ReactComponent as Jirafailedbuildstatusicon } from "./Icon/_JiraFailedBuildStatusIcon_.svg";
// import { ReactComponent as Jiralabsicon } from "./Icon/_JiraLabsIcon_.svg";
// import { ReactComponent as Jiratestsessionicon } from "./Icon/_JiraTestSessionIcon_.svg";
// import { ReactComponent as Labelicon } from "./Icon/_LabelIcon_.svg";
// import { ReactComponent as Lightbulbfilledicon } from "./Icon/_LightbulbFilledIcon_.svg";
import { ReactComponent as Lightbulbicon } from "./Icon/_LightbulbIcon_.svg";
// import { ReactComponent as Likeicon } from "./Icon/_LikeIcon_.svg";
// import { ReactComponent as Linkfilledicon } from "./Icon/_LinkFilledIcon_.svg";
// import { ReactComponent as Linkicon } from "./Icon/_LinkIcon_.svg";
// import { ReactComponent as Listicon } from "./Icon/_ListIcon_.svg";
// import { ReactComponent as Lobbyicon } from "./Icon/_LobbyIcon_.svg";
// import { ReactComponent as Locationicon } from "./Icon/_LocationIcon_.svg";
// import { ReactComponent as Lockcircleicon } from "./Icon/_LockCircleIcon_.svg";
// import { ReactComponent as Lockfilledicon } from "./Icon/_LockFilledIcon_.svg";
// import { ReactComponent as Lockicon } from "./Icon/_LockIcon_.svg";
// import { ReactComponent as Marketplaceicon } from "./Icon/_MarketplaceIcon_.svg";
// import { ReactComponent as Mediaattachmentcounticon } from "./Icon/_MediaAttachmentCountIcon_.svg";
// import { ReactComponent as Mediaservicesactualsizeicon } from "./Icon/_MediaServicesActualSizeIcon_.svg";
// import { ReactComponent as Mediaservicesaddcommenticon } from "./Icon/_MediaServicesAddCommentIcon_.svg";
// import { ReactComponent as Mediaservicesannotateicon } from "./Icon/_MediaServicesAnnotateIcon_.svg";
// import { ReactComponent as Mediaservicesarrowicon } from "./Icon/_MediaServicesArrowIcon_.svg";
// import { ReactComponent as Mediaservicesaudioicon } from "./Icon/_MediaServicesAudioIcon_.svg";
// import { ReactComponent as Mediaservicesbluricon } from "./Icon/_MediaServicesBlurIcon_.svg";
// import { ReactComponent as Mediaservicesbrushicon } from "./Icon/_MediaServicesBrushIcon_.svg";
// import { ReactComponent as Mediaservicesbuttonoptionicon } from "./Icon/_MediaServicesButtonOptionIcon_.svg";
// import { ReactComponent as Mediaservicescodeicon } from "./Icon/_MediaServicesCodeIcon_.svg";
// import { ReactComponent as Mediaservicesdocumenticon } from "./Icon/_MediaServicesDocumentIcon_.svg";
// import { ReactComponent as Mediaservicesfiltericon } from "./Icon/_MediaServicesFilterIcon_.svg";
// import { ReactComponent as Mediaservicesfittopageicon } from "./Icon/_MediaServicesFitToPageIcon_.svg";
// import { ReactComponent as Mediaservicesfullscreenicon } from "./Icon/_MediaServicesFullScreenIcon_.svg";
// import { ReactComponent as Mediaservicesgridicon } from "./Icon/_MediaServicesGridIcon_.svg";
// import { ReactComponent as Mediaservicesimageicon } from "./Icon/_MediaServicesImageIcon_.svg";
// import { ReactComponent as Mediaserviceslineicon } from "./Icon/_MediaServicesLineIcon_.svg";
// import { ReactComponent as Mediaserviceslinethicknessicon } from "./Icon/_MediaServicesLineThicknessIcon_.svg";
// import { ReactComponent as Mediaservicesnoimageicon } from "./Icon/_MediaServicesNoImageIcon_.svg";
// import { ReactComponent as Mediaservicesopenmediaviewericon } from "./Icon/_MediaServicesOpenMediaviewerIcon_.svg";
// import { ReactComponent as Mediaservicesovalicon } from "./Icon/_MediaServicesOvalIcon_.svg";
// import { ReactComponent as Mediaservicespdficon } from "./Icon/_MediaServicesPdfIcon_.svg";
// import { ReactComponent as Mediaservicespreselectedicon } from "./Icon/_MediaServicesPreselectedIcon_.svg";
// import { ReactComponent as Mediaservicespresentationicon } from "./Icon/_MediaServicesPresentationIcon_.svg";
// import { ReactComponent as Mediaservicesrectangleicon } from "./Icon/_MediaServicesRectangleIcon_.svg";
// import { ReactComponent as Mediaservicesscalelargeicon } from "./Icon/_MediaServicesScaleLargeIcon_.svg";
// import { ReactComponent as Mediaservicesscalesmallicon } from "./Icon/_MediaServicesScaleSmallIcon_.svg";
// import { ReactComponent as Mediaservicesspreadsheeticon } from "./Icon/_MediaServicesSpreadsheetIcon_.svg";
// import { ReactComponent as Mediaservicestexticon } from "./Icon/_MediaServicesTextIcon_.svg";
// import { ReactComponent as Mediaservicesunknownicon } from "./Icon/_MediaServicesUnknownIcon_.svg";
// import { ReactComponent as Mediaservicesvideoicon } from "./Icon/_MediaServicesVideoIcon_.svg";
// import { ReactComponent as Mediaserviceszipicon } from "./Icon/_MediaServicesZipIcon_.svg";
// import { ReactComponent as Mediaserviceszoominicon } from "./Icon/_MediaServicesZoomInIcon_.svg";
// import { ReactComponent as Mediaserviceszoomouticon } from "./Icon/_MediaServicesZoomOutIcon_.svg";
// import { ReactComponent as Mentionicon } from "./Icon/_MentionIcon_.svg";
// import { ReactComponent as Menuexpandicon } from "./Icon/_MenuExpandIcon_.svg";
// import { ReactComponent as Menuicon } from "./Icon/_MenuIcon_.svg";
// import { ReactComponent as Mobileicon } from "./Icon/_MobileIcon_.svg";
// import { ReactComponent as Moreicon } from "./Icon/_MoreIcon_.svg";
// import { ReactComponent as Moreverticalicon } from "./Icon/_MoreVerticalIcon_.svg";
// import { ReactComponent as Notificationallicon } from "./Icon/_NotificationAllIcon_.svg";
// import { ReactComponent as Notificationdirecticon } from "./Icon/_NotificationDirectIcon_.svg";
// import { ReactComponent as Notificationicon } from "./Icon/_NotificationIcon_.svg";
// import { ReactComponent as Officebuildingfilledicon } from "./Icon/_OfficeBuildingFilledIcon_.svg";
// import { ReactComponent as Officebuildingicon } from "./Icon/_OfficeBuildingIcon_.svg";
// import { ReactComponent as Oncallicon } from "./Icon/_OnCallIcon_.svg";
// import { ReactComponent as Openicon } from "./Icon/_OpenIcon_.svg";
// import { ReactComponent as Outgoingsoundicon } from "./Icon/_OutgoingSoundIcon_.svg";
// import { ReactComponent as Overviewicon } from "./Icon/_OverviewIcon_.svg";
// import { ReactComponent as Pagedoticon } from "./Icon/_PageDotIcon_.svg";
// import { ReactComponent as Pagefilledicon } from "./Icon/_PageFilledIcon_.svg";
// import { ReactComponent as Pageicon } from "./Icon/_PageIcon_.svg";
// import { ReactComponent as Pdficon } from "./Icon/_PdfIcon_.svg";
// import { ReactComponent as Peoplegroupicon } from "./Icon/_PeopleGroupIcon_.svg";
// import { ReactComponent as Peopleicon } from "./Icon/_PeopleIcon_.svg";
import { ReactComponent as Personcircleicon } from "./Icon/_PersonCircleIcon_.svg";
// import { ReactComponent as Personicon } from "./Icon/_PersonIcon_.svg";
// import { ReactComponent as Personwithcircleicon } from "./Icon/_PersonWithCircleIcon_.svg";
// import { ReactComponent as Personwithcrossicon } from "./Icon/_PersonWithCrossIcon_.svg";
// import { ReactComponent as Personwithtickicon } from "./Icon/_PersonWithTickIcon_.svg";
// import { ReactComponent as Portfolioicon } from "./Icon/_PortfolioIcon_.svg";
// import { ReactComponent as Preferencesicon } from "./Icon/_PreferencesIcon_.svg";
// import { ReactComponent as Premiumicon } from "./Icon/_PremiumIcon_.svg";
// import { ReactComponent as Presenceactiveicon } from "./Icon/_PresenceActiveIcon_.svg";
// import { ReactComponent as Presencebusyicon } from "./Icon/_PresenceBusyIcon_.svg";
// import { ReactComponent as Presenceunavailableicon } from "./Icon/_PresenceUnavailableIcon_.svg";
// import { ReactComponent as Questioncircleicon } from "./Icon/_QuestionCircleIcon_.svg";
// import { ReactComponent as Questionicon } from "./Icon/_QuestionIcon_.svg";
import { ReactComponent as Questionsicon } from "./Icon/_QuestionsIcon_.svg";
// import { ReactComponent as Queuesicon } from "./Icon/_QueuesIcon_.svg";
// import { ReactComponent as Quoteicon } from "./Icon/_QuoteIcon_.svg";
// import { ReactComponent as Radioicon } from "./Icon/_RadioIcon_.svg";
// import { ReactComponent as Recenticon } from "./Icon/_RecentIcon_.svg";
// import { ReactComponent as Redoicon } from "./Icon/_RedoIcon_.svg";
// import { ReactComponent as Refreshicon } from "./Icon/_RefreshIcon_.svg";
// import { ReactComponent as Retryicon } from "./Icon/_RetryIcon_.svg";
// import { ReactComponent as Roadmapicon } from "./Icon/_RoadmapIcon_.svg";
// import { ReactComponent as Roommenuicon } from "./Icon/_RoomMenuIcon_.svg";
// import { ReactComponent as Schedulefilledicon } from "./Icon/_ScheduleFilledIcon_.svg";
// import { ReactComponent as Scheduleicon } from "./Icon/_ScheduleIcon_.svg";
// import { ReactComponent as Screenicon } from "./Icon/_ScreenIcon_.svg";
// import { ReactComponent as Sdvideoicon } from "./Icon/_SdVideoIcon_.svg";
// import { ReactComponent as Searchicon } from "./Icon/_SearchIcon_.svg";
// import { ReactComponent as Selectclearicon } from "./Icon/_SelectClearIcon_.svg";
// import { ReactComponent as Sendicon } from "./Icon/_SendIcon_.svg";
// import { ReactComponent as Settingsicon } from "./Icon/_SettingsIcon_.svg";
// import { ReactComponent as Shareicon } from "./Icon/_ShareIcon_.svg";
// import { ReactComponent as Shipicon } from "./Icon/_ShipIcon_.svg";
// import { ReactComponent as Shortcuticon } from "./Icon/_ShortcutIcon_.svg";
import { ReactComponent as Signinicon } from "./Icon/_SignInIcon_.svg";
// import { ReactComponent as Signouticon } from "./Icon/_SignOutIcon_.svg";
// import { ReactComponent as Sprinticon } from "./Icon/_SprintIcon_.svg";
// import { ReactComponent as Starfilledicon } from "./Icon/_StarFilledIcon_.svg";
// import { ReactComponent as Staricon } from "./Icon/_StarIcon_.svg";
// import { ReactComponent as Starlargeicon } from "./Icon/_StarLargeIcon_.svg";
// import { ReactComponent as Statusicon } from "./Icon/_StatusIcon_.svg";
// import { ReactComponent as Stopwatchicon } from "./Icon/_StopwatchIcon_.svg";
// import { ReactComponent as Subtaskicon } from "./Icon/_SubtaskIcon_.svg";
import { ReactComponent as Suitcaseicon } from "./Icon/_SuitcaseIcon_.svg";
// import { ReactComponent as Switchericon } from "./Icon/_SwitcherIcon_.svg";
// import { ReactComponent as Tableicon } from "./Icon/_TableIcon_.svg";
// import { ReactComponent as Taskicon } from "./Icon/_TaskIcon_.svg";
// import { ReactComponent as Trashicon } from "./Icon/_TrashIcon_.svg";
// import { ReactComponent as Trayicon } from "./Icon/_TrayIcon_.svg";
// import { ReactComponent as Undoicon } from "./Icon/_UndoIcon_.svg";
// import { ReactComponent as Unlinkicon } from "./Icon/_UnlinkIcon_.svg";
// import { ReactComponent as Unlockcircleicon1 } from "./Icon/_UnlockCircleIcon_-1.svg";
// import { ReactComponent as Unlockcircleicon } from "./Icon/_UnlockCircleIcon_.svg";
// import { ReactComponent as Unlockfilledicon1 } from "./Icon/_UnlockFilledIcon_-1.svg";
// import { ReactComponent as Unlockfilledicon } from "./Icon/_UnlockFilledIcon_.svg";
// import { ReactComponent as Unlockicon } from "./Icon/_UnlockIcon_.svg";
// import { ReactComponent as Uploadicon1 } from "./Icon/_UploadIcon_-1.svg";
// import { ReactComponent as Uploadicon } from "./Icon/_UploadIcon_.svg";
import { ReactComponent as Useravatarcircleicon } from "./Icon/_UserAvatarCircleIcon_.svg";
// import { ReactComponent as Vidaudiomutedicon } from "./Icon/_VidAudioMutedIcon_.svg";
// import { ReactComponent as Vidaudioonicon } from "./Icon/_VidAudioOnIcon_.svg";
// import { ReactComponent as Vidbackwardicon } from "./Icon/_VidBackwardIcon_.svg";
// import { ReactComponent as Vidcameraofficon } from "./Icon/_VidCameraOffIcon_.svg";
// import { ReactComponent as Vidcameraonicon } from "./Icon/_VidCameraOnIcon_.svg";
// import { ReactComponent as Vidconnectioncircleicon } from "./Icon/_VidConnectionCircleIcon_.svg";
// import { ReactComponent as Videocircleicon } from "./Icon/_VideoCircleIcon_.svg";
// import { ReactComponent as Videofilledicon } from "./Icon/_VideoFilledIcon_.svg";
// import { ReactComponent as Vidforwardicon } from "./Icon/_VidForwardIcon_.svg";
// import { ReactComponent as Vidfullscreenofficon } from "./Icon/_VidFullScreenOffIcon_.svg";
// import { ReactComponent as Vidfullscreenonicon } from "./Icon/_VidFullScreenOnIcon_.svg";
// import { ReactComponent as Vidhangupicon } from "./Icon/_VidHangUpIcon_.svg";
// import { ReactComponent as Vidhdcircleicon } from "./Icon/_VidHdCircleIcon_.svg";
// import { ReactComponent as Vidpauseicon } from "./Icon/_VidPauseIcon_.svg";
// import { ReactComponent as Vidplayicon } from "./Icon/_VidPlayIcon_.svg";
// import { ReactComponent as Vidraisedhandicon } from "./Icon/_VidRaisedHandIcon_.svg";
// import { ReactComponent as Vidsharescreenicon } from "./Icon/_VidShareScreenIcon_.svg";
// import { ReactComponent as Vidspeakingcircleicon } from "./Icon/_VidSpeakingCircleIcon_.svg";
// import { ReactComponent as Vidvolumefullicon } from "./Icon/_VidVolumeFullIcon_.svg";
// import { ReactComponent as Vidvolumehalficon } from "./Icon/_VidVolumeHalfIcon_.svg";
// import { ReactComponent as Vidvolumemutedicon } from "./Icon/_VidVolumeMutedIcon_.svg";
// import { ReactComponent as Warningicon } from "./Icon/_WarningIcon_.svg";
// import { ReactComponent as Watchfilledicon } from "./Icon/_WatchFilledIcon_.svg";
// import { ReactComponent as Watchicon } from "./Icon/_WatchIcon_.svg";
// import { ReactComponent as Worldicon } from "./Icon/_WorldIcon_.svg";
// import { ReactComponent as Worldsmallicon } from "./Icon/_WorldSmallIcon_.svg";

const designicons = {
  //   ActivityIcon: Activityicon,
  //   AddCircleIcon: Addcircleicon,
  //   AddIcon: Addicon,
  //   AddItemIcon: Additemicon,
  //   AddonIcon: Addonicon,
  //   AppAccessIcon: Appaccessicon,
  //   AppSwitcherIcon: Appswitchericon,
  //   ArchiveIcon: Archiveicon,
  //   ArrowDownCircleIcon: Arrowdowncircleicon,
  //   ArrowDownIcon: Arrowdownicon,
  //   ArrowLeftCircleIcon: Arrowleftcircleicon,
  //   ArrowLeftIcon: Arrowlefticon,
  //   ArrowRightCircleIcon: Arrowrightcircleicon,
  //   ArrowRightIcon: Arrowrighticon,
  //   ArrowUpCircleIcon: Arrowupcircleicon,
  //   ArrowUpIcon: Arrowupicon,
  //   AttachmentIcon: Attachmenticon,
  //   AudioCircleIcon: Audiocircleicon,
  //   AudioIcon: Audioicon,
  //   AudioOnlyIcon: Audioonlyicon,
  BacklogIcon: Backlogicon,
  //   BillingFilledIcon: Billingfilledicon,
  //   BillingIcon: Billingicon,
  //   BlogIcon: Blogicon,
  //   BoardIcon: Boardicon,
  BookIcon: Bookicon,
  //   BulletListIcon: Bulletlisticon,
  //   CalendarFilledIcon: Calendarfilledicon,
  //   CalendarIcon: Calendaricon,
  //   CameraFilledIcon: Camerafilledicon,
  //   CameraIcon: Cameraicon,
  Cash: Cash,
  Pi: Pi,
  //   _BitbuckerBranchesIcon_: Bitbuckerbranchesicon,
  //   _BitbuckerBuildsIcon_: Bitbuckerbuildsicon,
  //   _BitbuckerCloneIcon_: Bitbuckercloneicon,
  //   _BitbuckerCommitsIcon_: Bitbuckercommitsicon,
  //   _BitbuckerCompareIcon_: Bitbuckercompareicon,
  //   _BitbuckerDeploymentsIcon_: Bitbuckerdeploymentsicon,
  //   _BitbuckerForksIcon_: Bitbuckerforksicon,
  //   _BitbuckerOutputIcon_: Bitbuckeroutputicon,
  //   _BitbuckerPipelinesIcon_: Bitbuckerpipelinesicon,
  //   _BitbuckerPullrequestsIcon_: Bitbuckerpullrequestsicon,
  //   _BitbuckerReposIcon_: Bitbuckerreposicon,
  //   _BitbuckerSnippetsIcon_: Bitbuckersnippetsicon,
  //   _BitbuckerSourceIcon_: Bitbuckersourceicon,
  //   _CameraRotateIcon_: Camerarotateicon,
  //   _CameraTakePictureIcon_: Cameratakepictureicon,
  //   _CanvasIcon_: Canvasicon,
  //   _CheckboxIcon_: Checkboxicon,
  //   _CheckboxIndeterminateIcon_: Checkboxindeterminateicon,
  //   _CheckCircleIcon_: Checkcircleicon,
  //   _CheckCircleOutlineIcon_: Checkcircleoutlineicon,
  //   _CheckIcon_: Checkicon,
  //   _ChevronDoubleDownIcon_: Chevrondoubledownicon,
  //   _ChevronDoubleUpIcon_: Chevrondoubleupicon,
  //   _ChevronDownCircleIcon_: Chevrondowncircleicon,
  //   _ChevronDownIcon_: Chevrondownicon,
  //   _ChevronLeftCircleIcon_: Chevronleftcircleicon,
  //   _ChevronLeftIcon_: Chevronlefticon,
  //   _ChevronLeftLargeIcon_: Chevronleftlargeicon,
  _ChevronRightCircleIcon_: Chevronrightcircleicon,
  //   _ChevronRightIcon_: Chevronrighticon,
  //   _ChevronRightLargeIcon_: Chevronrightlargeicon,
  //   _ChevronUpCircleIcon_: Chevronupcircleicon,
  //   _ChevronUpIcon_: Chevronupicon,
  //   _ChildIssuesIcon_: Childissuesicon,
  //   _CodeIcon_: Codeicon,
  //   _CommentIcon_: Commenticon,
  //   _ComponentIcon_: Componenticon,
  //   _CopyIcon_: Copyicon,
  //   _CreditcardFilledIcon_: Creditcardfilledicon,
  //   _CreditcardIcon_: Creditcardicon,
  //   _CrossCircleIcon_: Crosscircleicon,
  //   _CrossIcon_: Crossicon,
  //   _DashboardIcon_: Dashboardicon,
  //   _DecisionIcon_: Decisionicon,
  //   _DepartmentIcon_: Departmenticon,
  //   _DetailViewIcon_: Detailviewicon,
  _DialOutIcon_: Dialouticon,
  //   _DiscoverFilledIcon_: Discoverfilledicon,
  //   _DiscoverIcon_: Discovericon,
  //   _DocumentFilledIcon_: Documentfilledicon,
  //   _DocumentIcon_: Documenticon,
  //   _DocumentsIcon_: Documentsicon,
  //   _DownloadIcon_: Downloadicon,
  //   _DragHandlerIcon_: Draghandlericon,
  //   _DropboxIcon_: Dropboxicon,
  //   _EditFilledIcon_: Editfilledicon,
  //   _EditIcon_: Editicon,
  //   _EditorAddIcon_: Editoraddicon,
  //   _EditorAddonIcon_: Editoraddonicon,
  //   _EditorAdvancedIcon_: Editoradvancedicon,
  //   _EditorAlignCenterIcon_: Editoraligncentericon,
  //   _EditorAlignImageCenterIcon_: Editoralignimagecentericon,
  //   _EditorAlignImageLeftIcon_: Editoralignimagelefticon,
  //   _EditorAlignImageRightIcon_: Editoralignimagerighticon,
  //   _EditorAlignLeftIcon_: Editoralignlefticon,
  //   _EditorAlignRightIcon_: Editoralignrighticon,
  //   _EditorAttachmentIcon_: Editorattachmenticon,
  //   _EditorBackgroundColorIcon_: Editorbackgroundcoloricon,
  //   _EditorBoldIcon_: Editorboldicon,
  //   _EditorBulletListIcon_: Editorbulletlisticon,
  //   _EditorCloseIcon_: Editorcloseicon,
  //   _EditorCodeIcon_: Editorcodeicon,
  //   _EditorCollapseIcon_: Editorcollapseicon,
  //   _EditorDateIcon_: Editordateicon,
  //   _EditorDecisionIcon_: Editordecisionicon,
  //   _EditorDividerIcon_: Editordividericon,
  //   _EditorDoneIcon_: Editordoneicon,
  //   _EditorEditIcon_: Editorediticon,
  //   _EditorEmojiIcon_: Editoremojiicon,
  //   _EditorErrorIcon_: Editorerroricon,
  //   _EditorExpandIcon_: Editorexpandicon,
  //   _EditorFeedbackIcon_: Editorfeedbackicon,
  //   _EditorFileIcon_: Editorfileicon,
  //   _EditorFilePreviewIcon_: Editorfilepreviewicon,
  //   _EditorHelpIcon_: Editorhelpicon,
  //   _EditorHintIcon_: Editorhinticon,
  //   _EditorHorizontalRuleIcon_: Editorhorizontalruleicon,
  //   _EditorImageBorderIcon_: Editorimagebordericon,
  //   _EditorImageIcon_: Editorimageicon,
  //   _EditorImageResizeIcon_: Editorimageresizeicon,
  //   _EditorIndentIcon_: Editorindenticon,
  //   _EditorInfoIcon_: Editorinfoicon,
  //   _EditorItalicIcon_: Editoritalicicon,
  //   _EditorLayoutSingleIcon_: Editorlayoutsingleicon,
  //   _EditorLayoutThreeEqualIcon_: Editorlayoutthreeequalicon,
  //   _EditorLayoutThreeWithSidebarsIcon_: Editorlayoutthreewithsidebarsicon,
  //   _EditorLayoutTwoEqualIcon_: Editorlayouttwoequalicon,
  //   _EditorLayoutTwoLeftSidebarIcon_: Editorlayouttwoleftsidebaricon,
  //   _EditorLayoutTwoRightSidebarIcon_: Editorlayouttworightsidebaricon,
  //   _EditorLinkIcon_: Editorlinkicon,
  //   _EditorMediaCenterIcon_: Editormediacentericon,
  //   _EditorMediaFullWidthIcon_: Editormediafullwidthicon,
  //   _EditorMediaWideIcon_: Editormediawideicon,
  //   _EditorMediaWrapLeftIcon_: Editormediawraplefticon,
  //   _EditorMediaWrapRightIcon_: Editormediawraprighticon,
  //   _EditorMentionIcon_: Editormentionicon,
  //   _EditorMoreIcon_: Editormoreicon,
  //   _EditorNoteIcon_: Editornoteicon,
  //   _EditorNumberListIcon_: Editornumberlisticon,
  //   _EditorOpenIcon_: Editoropenicon,
  //   _EditorOutdentIcon_: Editoroutdenticon,
  //   _EditorPanelIcon_: Editorpanelicon,
  //   _EditorPhotoIcon_: Editorphotoicon,
  //   _EditorQuoteIcon_: Editorquoteicon,
  //   _EditorRecentIcon_: Editorrecenticon,
  //   _EditorRedoIcon_: Editorredoicon,
  //   _EditorRemoveEmojiIcon_: Editorremoveemojiicon,
  //   _EditorRemoveIcon_: Editorremoveicon,
  //   _EditorSearchIcon_: Editorsearchicon,
  //   _EditorSettingsIcon_: Editorsettingsicon,
  //   _EditorStrikethroughIcon_: Editorstrikethroughicon,
  //   _EditorSuccessIcon_: Editorsuccessicon,
  //   _EditorTableDisplayOptionsIcon_: Editortabledisplayoptionsicon,
  //   _EditorTableIcon_: Editortableicon,
  //   _EditorTaskIcon_: Editortaskicon,
  //   _EditorTextColorIcon_: Editortextcoloricon,
  //   _EditorTextStyleIcon_: Editortextstyleicon,
  //   _EditorUnderlineIcon_: Editorunderlineicon,
  //   _EditorUndoIcon_: Editorundoicon,
  //   _EditorUnlinkIcon_: Editorunlinkicon,
  //   _EditorWarningIcon_: Editorwarningicon,
  //   _EmailIcon_: Emailicon,
  //   _EmojiActivity_: Emojiactivity,
  //   _EmojiAddIcon_: Emojiaddicon,
  //   _EmojiAtlassian_: Emojiatlassian,
  //   _EmojiCustom_: Emojicustom,
  //   _EmojiEmoji_: Emojiemoji,
  //   _EmojiFlags_: Emojiflags,
  //   _EmojiFood_: Emojifood,
  //   _EmojiFrequent_: Emojifrequent,
  //   _EmojiIcon_: Emojiicon,
  //   _EmojiKeyboard_: Emojikeyboard,
  //   _EmojiNature_: Emojinature,
  //   _EmojiObjects_: Emojiobjects,
  //   _EmojiPeople_: Emojipeople,
  //   _EmojiProductivity_: Emojiproductivity,
  //   _EmojiSymbols_: Emojisymbols,
  //   _EmojiTravel_: Emojitravel,
  //   _ErrorIcon_: Erroricon,
  //   _ExportIcon_: Exporticon,
  //   _FeedbackIcon_: Feedbackicon,
  //   _FileIcon_: Fileicon,
  //   _FilterIcon_: Filtericon,
  //   _FlagFilledIcon_: Flagfilledicon,
  //   _FolderFilledIcon_: Folderfilledicon,
  //   _FolderIcon_: Foldericon,
  //   _FollowersIcon_: Followersicon,
  //   _FollowingIcon_: Followingicon,
  //   _GoogledriveIcon_: Googledriveicon,
  //   _GraphBarIcon_: Graphbaricon,
  //   _GraphLineIcon_: Graphlineicon,
  //   _GsuiteIcon_: Gsuiteicon,
  _HighlightsIcon_: Highlightsicon,
  //   _HomeCircleIcon_: Homecircleicon,
  _HomeIcon_: Homeicon,
  //   _ImageBorderIcon_: Imagebordericon,
  //   _ImageIcon_: Imageicon,
  //   _ImageResizeIcon_: Imageresizeicon,
  //   _InfoIcon_: Infoicon,
  //   _InviteTeamIcon_: Inviteteamicon,
  //   _IssueIcon_: Issueicon,
  //   _IssueRaiseIcon_: Issueraiseicon,
  //   _IssuesIcon_: Issuesicon,
  //   _JiraCaptureIcon_: Jiracaptureicon,
  //   _JiraFailedBuildStatusIcon_: Jirafailedbuildstatusicon,
  //   _JiraLabsIcon_: Jiralabsicon,
  //   _JiraTestSessionIcon_: Jiratestsessionicon,
  //   _LabelIcon_: Labelicon,
  //   _LightbulbFilledIcon_: Lightbulbfilledicon,
  _LightbulbIcon_: Lightbulbicon,
  //   _LikeIcon_: Likeicon,
  //   _LinkFilledIcon_: Linkfilledicon,
  //   _LinkIcon_: Linkicon,
  //   _ListIcon_: Listicon,
  //   _LobbyIcon_: Lobbyicon,
  //   _LocationIcon_: Locationicon,
  //   _LockCircleIcon_: Lockcircleicon,
  //   _LockFilledIcon_: Lockfilledicon,
  //   _LockIcon_: Lockicon,
  //   _MarketplaceIcon_: Marketplaceicon,
  //   _MediaAttachmentCountIcon_: Mediaattachmentcounticon,
  //   _MediaServicesActualSizeIcon_: Mediaservicesactualsizeicon,
  //   _MediaServicesAddCommentIcon_: Mediaservicesaddcommenticon,
  //   _MediaServicesAnnotateIcon_: Mediaservicesannotateicon,
  //   _MediaServicesArrowIcon_: Mediaservicesarrowicon,
  //   _MediaServicesAudioIcon_: Mediaservicesaudioicon,
  //   _MediaServicesBlurIcon_: Mediaservicesbluricon,
  //   _MediaServicesBrushIcon_: Mediaservicesbrushicon,
  //   _MediaServicesButtonOptionIcon_: Mediaservicesbuttonoptionicon,
  //   _MediaServicesCodeIcon_: Mediaservicescodeicon,
  //   _MediaServicesDocumentIcon_: Mediaservicesdocumenticon,
  //   _MediaServicesFilterIcon_: Mediaservicesfiltericon,
  //   _MediaServicesFitToPageIcon_: Mediaservicesfittopageicon,
  //   _MediaServicesFullScreenIcon_: Mediaservicesfullscreenicon,
  //   _MediaServicesGridIcon_: Mediaservicesgridicon,
  //   _MediaServicesImageIcon_: Mediaservicesimageicon,
  //   _MediaServicesLineIcon_: Mediaserviceslineicon,
  //   _MediaServicesLineThicknessIcon_: Mediaserviceslinethicknessicon,
  //   _MediaServicesNoImageIcon_: Mediaservicesnoimageicon,
  //   _MediaServicesOpenMediaviewerIcon_: Mediaservicesopenmediaviewericon,
  //   _MediaServicesOvalIcon_: Mediaservicesovalicon,
  //   _MediaServicesPdfIcon_: Mediaservicespdficon,
  //   _MediaServicesPreselectedIcon_: Mediaservicespreselectedicon,
  //   _MediaServicesPresentationIcon_: Mediaservicespresentationicon,
  //   _MediaServicesRectangleIcon_: Mediaservicesrectangleicon,
  //   _MediaServicesScaleLargeIcon_: Mediaservicesscalelargeicon,
  //   _MediaServicesScaleSmallIcon_: Mediaservicesscalesmallicon,
  //   _MediaServicesSpreadsheetIcon_: Mediaservicesspreadsheeticon,
  //   _MediaServicesTextIcon_: Mediaservicestexticon,
  //   _MediaServicesUnknownIcon_: Mediaservicesunknownicon,
  //   _MediaServicesVideoIcon_: Mediaservicesvideoicon,
  //   _MediaServicesZipIcon_: Mediaserviceszipicon,
  //   _MediaServicesZoomInIcon_: Mediaserviceszoominicon,
  //   _MediaServicesZoomOutIcon_: Mediaserviceszoomouticon,
  //   _MentionIcon_: Mentionicon,
  //   _MenuExpandIcon_: Menuexpandicon,
  //   _MenuIcon_: Menuicon,
  //   _MobileIcon_: Mobileicon,
  //   _MoreIcon_: Moreicon,
  //   _MoreVerticalIcon_: Moreverticalicon,
  //   _NotificationAllIcon_: Notificationallicon,
  //   _NotificationDirectIcon_: Notificationdirecticon,
  //   _NotificationIcon_: Notificationicon,
  //   _OfficeBuildingFilledIcon_: Officebuildingfilledicon,
  //   _OfficeBuildingIcon_: Officebuildingicon,
  //   _OnCallIcon_: Oncallicon,
  //   _OpenIcon_: Openicon,
  //   _OutgoingSoundIcon_: Outgoingsoundicon,
  //   _OverviewIcon_: Overviewicon,
  //   _PageDotIcon_: Pagedoticon,
  //   _PageFilledIcon_: Pagefilledicon,
  //   _PageIcon_: Pageicon,
  //   _PdfIcon_: Pdficon,
  //   _PeopleGroupIcon_: Peoplegroupicon,
  //   _PeopleIcon_: Peopleicon,
  _PersonCircleIcon_: Personcircleicon,
  //   _PersonIcon_: Personicon,
  //   _PersonWithCircleIcon_: Personwithcircleicon,
  //   _PersonWithCrossIcon_: Personwithcrossicon,
  //   _PersonWithTickIcon_: Personwithtickicon,
  //   _PortfolioIcon_: Portfolioicon,
  //   _PreferencesIcon_: Preferencesicon,
  //   _PremiumIcon_: Premiumicon,
  //   _PresenceActiveIcon_: Presenceactiveicon,
  //   _PresenceBusyIcon_: Presencebusyicon,
  //   _PresenceUnavailableIcon_: Presenceunavailableicon,
  //   _QuestionCircleIcon_: Questioncircleicon,
  //   _QuestionIcon_: Questionicon,
  _QuestionsIcon_: Questionsicon,
  //   _QueuesIcon_: Queuesicon,
  //   _QuoteIcon_: Quoteicon,
  //   _RadioIcon_: Radioicon,
  //   _RecentIcon_: Recenticon,
  //   _RedoIcon_: Redoicon,
  //   _RefreshIcon_: Refreshicon,
  //   _RetryIcon_: Retryicon,
  //   _RoadmapIcon_: Roadmapicon,
  //   _RoomMenuIcon_: Roommenuicon,
  //   _ScheduleFilledIcon_: Schedulefilledicon,
  //   _ScheduleIcon_: Scheduleicon,
  //   _ScreenIcon_: Screenicon,
  //   _SdVideoIcon_: Sdvideoicon,
  //   _SearchIcon_: Searchicon,
  //   _SelectClearIcon_: Selectclearicon,
  //   _SendIcon_: Sendicon,
  //   _SettingsIcon_: Settingsicon,
  //   _ShareIcon_: Shareicon,
  //   _ShipIcon_: Shipicon,
  //   _ShortcutIcon_: Shortcuticon,
  _SignInIcon_: Signinicon,
  //   _SignOutIcon_: Signouticon,
  //   _SprintIcon_: Sprinticon,
  //   _StarFilledIcon_: Starfilledicon,
  //   _StarIcon_: Staricon,
  //   _StarLargeIcon_: Starlargeicon,
  //   _StatusIcon_: Statusicon,
  //   _StopwatchIcon_: Stopwatchicon,
  //   _SubtaskIcon_: Subtaskicon,
  _SuitcaseIcon_: Suitcaseicon,
  //   _SwitcherIcon_: Switchericon,
  //   _TableIcon_: Tableicon,
  //   _TaskIcon_: Taskicon,
  //   _TrashIcon_: Trashicon,
  //   _TrayIcon_: Trayicon,
  //   _UndoIcon_: Undoicon,
  //   _UnlinkIcon_: Unlinkicon,
  //   _UnlockCircleIcon_: Unlockcircleicon,
  //   _UnlockFilledIcon_: Unlockfilledicon,
  //   _UnlockIcon_: Unlockicon,
  //   _UploadIcon_: Uploadicon,
  _UserAvatarCircleIcon_: Useravatarcircleicon,
  //   _VidAudioMutedIcon_: Vidaudiomutedicon,
  //   _VidAudioOnIcon_: Vidaudioonicon,
  //   _VidBackwardIcon_: Vidbackwardicon,
  //   _VidCameraOffIcon_: Vidcameraofficon,
  //   _VidCameraOnIcon_: Vidcameraonicon,
  //   _VidConnectionCircleIcon_: Vidconnectioncircleicon,
  //   _VideoCircleIcon_: Videocircleicon,
  //   _VideoFilledIcon_: Videofilledicon,
  //   _VidForwardIcon_: Vidforwardicon,
  //   _VidFullScreenOffIcon_: Vidfullscreenofficon,
  //   _VidFullScreenOnIcon_: Vidfullscreenonicon,
  //   _VidHangUpIcon_: Vidhangupicon,
  //   _VidHdCircleIcon_: Vidhdcircleicon,
  //   _VidPauseIcon_: Vidpauseicon,
  //   _VidPlayIcon_: Vidplayicon,
  //   _VidRaisedHandIcon_: Vidraisedhandicon,
  //   _VidShareScreenIcon_: Vidsharescreenicon,
  //   _VidSpeakingCircleIcon_: Vidspeakingcircleicon,
  //   _VidVolumeFullIcon_: Vidvolumefullicon,
  //   _VidVolumeHalfIcon_: Vidvolumehalficon,
  //   _VidVolumeMutedIcon_: Vidvolumemutedicon,
  //   _WarningIcon_: Warningicon,
  //   _WatchFilledIcon_: Watchfilledicon,
  //   _WatchIcon_: Watchicon,
  //   _WorldIcon_: Worldicon,
  //   _WorldSmallIcon_: Worldsmallicon,
};

export default designicons;
